import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { CALLOUTS_BANNER_DIMENSIONS } from "@dineout-payment-success-ui/constants/CalloutsBanner";

export const CalloutsBannerWrapper = styled.div(({ theme }) => ({
    width: "100%",
    paddingLeft: theme.spacing.medium,
    paddingRight: theme.spacing.medium,
    margin: `${theme.spacing.large} 0`,
}));

export const CalloutsBannerTitleLottieWrapper = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: theme.spacing.xxSmall,
    height: CALLOUTS_BANNER_DIMENSIONS.titleLottieHeight,
    width: "100%",
}));

export const CalloutsBannerContentWrapper = styled.div<{ isClickable?: boolean }>(({ isClickable }) => ({
    width: "106%",
    minHeight: CALLOUTS_BANNER_DIMENSIONS.bannerMinHeight,
    borderRadius: CALLOUTS_BANNER_DIMENSIONS.bannerBorderRadius,
    cursor: isClickable ? "pointer" : "default",
    marginLeft: "-3%",
    overflow: "hidden",
}));

export const CalloutsBannerLottieWrapper = styled.div({
    width: "100%",
    minHeight: CALLOUTS_BANNER_DIMENSIONS.bannerMinHeight,
});

export const HtmlText = styled(Text)(({ theme }) => ({
    "& > ul": {
        padding: `${theme.spacing.xxSmall} 0`,
        paddingBottom: 0,
        margin: 0,
        listStyleType: "disc",
        listStylePosition: "outside",
        paddingLeft: theme.spacing.medium,
    },
    "& > ol": {
        padding: `${theme.spacing.xxSmall} 0`,
        paddingBottom: 0,
        margin: 0,
        listStyleType: "decimal",
        listStylePosition: "outside",
        paddingLeft: theme.spacing.medium,
    },
    "& li": {
        marginBottom: theme.spacing.xxSmall,
    },
}));

export const CalloutsBannerHalfCardWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.medium,
    padding: theme.spacing.medium,
}));

export const CalloutsBannerHalfCardHeader = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: theme.spacing.small,
    position: "relative",
    marginTop: theme.spacing.xSmall,
}));

export const CalloutsBannerHalfCardTitle = styled(HtmlText)({
    minWidth: 0,
    width: CALLOUTS_BANNER_DIMENSIONS.calloutTitleWidth,
});

export const CalloutsBannerHalfCardImageWrap = styled.div({
    flexShrink: 0,
    width: CALLOUTS_BANNER_DIMENSIONS.calloutImageWidthSize,
    height: CALLOUTS_BANNER_DIMENSIONS.calloutImageHeightSize,
    position: "absolute",
    right: CALLOUTS_BANNER_DIMENSIONS.calloutImageRightOffset,
    top: CALLOUTS_BANNER_DIMENSIONS.calloutImageTopOffset,
});

export const CalloutsBannerHalfCardDescription = styled(HtmlText)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_High_Emphasis,
    width: CALLOUTS_BANNER_DIMENSIONS.calloutDescriptionWidth,
    fontSize: theme.spacing.x7,
    "& > ul > li": { 
        marginBottom: theme.spacing.medium,
    },
    "& > ul > li:last-child": {
        marginBottom: 0,
    }
}));

export const CalloutsBannerHalfCardCtaWrap = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
}));
